exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host(.skin1) g > g:nth-of-type(1) {\n  fill: #EC3A3C;\n  opacity: .99; }\n\n:host(.skin2) g > g:nth-of-type(2) {\n  fill: #EC3A3C;\n  opacity: .99; }\n\n:host(.skin3) g > g:nth-of-type(3) {\n  fill: #EC3A3C;\n  opacity: .99; }\n\ntext {\n  fill: #EC3A3C;\n  font-size: 8px; }\n\nsvg > g {\n  fill: #EC3A3C; }\n\nsvg > g > g {\n  fill: #fff;\n  opacity: .2; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/power-planner/power-planner/src/app/core.module/executor.component/executor.component.scss
// module id = ../../../../../src/app/core.module/executor.component/executor.component.scss
// module chunks = main